<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="1400">
			<v-card>
				<v-card-title class="h6 pr-2">
					<span>Print Preview</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="4" class="px-5" app>
							<div class="pb-3">
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Header</div>
									<v-checkbox v-model="header" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Surat</div>
									<v-checkbox v-model="detailInvoice" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Detail Produk</div>
									<v-checkbox v-model="detailProduct" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2">
									<div class="text-subtitle-1">Tanda Tangan</div>
									<v-checkbox v-model="signature" class="mt-0" hide-details></v-checkbox>
								</div>
								<div class="d-flex justify-space-between black--text mt-2" v-if="detailSDO.sdo_status != 'created'">
									<div class="text-subtitle-1">Catatan</div>
									<v-checkbox v-model="note" class="mt-0" hide-details></v-checkbox>
								</div>
							</div>
							<v-btn text large depressed class="primary col-12 mt-5" @click="printDiv(detailSDO.sdo_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2">Print</div>
							</v-btn>
						</v-col>
						<v-col cols="8" class="deep-purple lighten-5 rounded-lg frame-pdf">
							<v-card elevation="10" tile class="pa-5" id="section-to-print" v-if="false">
								<div class="white" id="inprint">
									<div class="text-center">
										<img width="90" src="/assets/icon/milagros-icon.png">
									</div>
									<v-row class="pt-2">
										<v-col cols="3">
											<div v-if="sdoDate" class="text-body-2 font-weight-bold">Tanggal</div>
											<div v-if="sdoStatus" class="text-body-2 font-weight-bold pt-2">Status</div>
										</v-col>
										<v-col cols="9" class="pl-0">
											<div v-if="sdoDate" class="text-body-2">{{ detailSDO.sdo_status_created_datetime | haritanggaljam }}</div>
											<div class="pt-2" v-if="sdoStatus">{{ detailSDO.sdo_status | toStatusSDOWH }}</div>
										</v-col>
									</v-row>
									<div class="mt-4" v-if="paySummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th colspan="2" class="text-body-2 black--text text-left font-weight-bold">Ringkasan Pembayaran</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>Total Belanja</td>
															<td class="text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row class="pb-3">
											<v-col cols="6" class="pb-0"></v-col>
											<v-col cols="6" class="pb-0">
												<v-card outlined class="pa-4 deep-purple lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="pb-3">
										<div class="border-topbot-dotted py-3 mt-5">
											<v-row>
												<v-col cols="6" class="pb-0">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2 font-weight-bold">Nomor</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2 font-weight-bold">{{ detailSDO.sdo_code }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
											<v-row>
												<v-col cols="6">
													<v-row>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Atas nama</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSDO.sdo_status_created_user_name }}</span>
														</v-col>
														<v-col cols="5" class="py-0">
															<div class="text-body-2">Tanggal</div>
														</v-col>
														<v-col cols="7" class="py-0">
															<span class="pr-2">:</span>
															<span class="text-body-2">{{ detailSDO.sdo_status_created_datetime | tanggal }}</span>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</div>
									</div>
									<div class="pb-3" v-if="dateSummary">
										<v-card outlined class="mt-5">
											<v-row class="py-3">
												<v-col cols="6" class="py-0">
													<div>
														<v-row class="px-3">
															<v-col cols="5" class="pr-0 py-0">
																<div class="text-body-2">
																	<span>Tanggal Dikirim</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0 pr-0">
																<div class="text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailSDO.sdo_status_on_delivery_datetime | tanggal }}</span>
																</div>
															</v-col>
															<v-col cols="5" class="pr-0 py-0">
																<div class="pt-2 text-body-2">
																	<span>Tanggal Diterima</span>
																</div>
															</v-col>
															<v-col cols="7" class="py-0 pr-0">
																<div class="pt-2 text-body-2">
																	<span class="pr-2">:</span>
																	<span>{{ detailSDO.sdo_status_delivered_datetime | tanggal }}</span>
																</div>
															</v-col>
														</v-row>
													</div>
												</v-col>
											</v-row>
										</v-card>
									</div>
									<div class="mt-5" v-if="productSummary">
										<v-card outlined>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Jumlah</th>
															<th class="text-center">Berat</th>
															<th class="text-right">Harga(Rp)</th>
															<th class="text-right">Subtotal(Rp)</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="product in detailSDO.sdo_detail" :key="product.sdo_detail_id">
															<td class="text-left">{{ product.sdo_detail_product_name }}</td>
															<td class="text-center">
																<div>{{ product.sdo_detail_quantity_sent | toNumber }}</div>
															</td>
															<td class="text-center">{{ product.sdo_detail_product_weight | toKg }}</td>
															<td class="text-right">{{ product.sdo_detail_product_price | toNumber }}</td>
															<td class="text-right">{{ product.sdo_detail_product_price * product.sdo_detail_quantity_sent | toNumber }}</td>
														</tr>
														<tr>
															<td colspan="4" class="font-weight-bold text-right">Total Harga</td>
															<td class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
										<v-row>
											<v-col cols="6"></v-col>
											<v-col cols="6">
												<v-card outlined class="pa-4 deep-purple lighten-5">
													<v-row>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold">Total Bayar</div>
														</v-col>
														<v-col cols="6" class="py-0">
															<div class="font-weight-bold text-right">{{ grandTotal | toRupiah }}</div>
														</v-col>
													</v-row>
												</v-card>
											</v-col>
										</v-row>
									</div>
									<div class="mt-5" v-if="note">
										<div class="text-body-2 font-weight-bold">Catatan</div>
										<div v-for="product in detailSDO.sdo_detail" :key="product.sdo_detail_id">
											<div class="pt-2 text-body-2">Jumlah {{ product.sdo_detail_product_name }} diterima {{ product.sdo_detail_quantity_received }}</div>
										</div>
									</div>
								</div>
							</v-card>
							<v-card elevation="10" tile class="pa-5">
								<div class="white in-print" id="box-print">
									<div class="pb-3" v-if="header">
										<div class="d-flex flex-wrap border-bottom border-2px">
											<v-col cols="9" class="pt-0 px-0">
												<div class="d-flex justify-start">
													<div class="d-flex align-center">
														<img width="110" height="auto" src="/assets/icon/milagros-icon.png">
													</div>
													<div class="ml-4">
														<div class="font-size-14 font-weight-bold"><!-- {{ letterHeader.letter_title }} --></div>
														<div class="pt-1 font-size-9">
															<div>{{ letterHeader.letter_address }}</div>
															<div>Phone: {{ letterHeader.letter_phone }}</div>
															<div>email: {{ letterHeader.letter_email }}</div>
															<div>web: {{ letterHeader.letter_web }}</div>
														</div>
													</div>
												</div>
											</v-col>
											<v-col cols="3" class="pt-0 px-0 my-auto">
												<div class="d-flex justify-end">
													<div class="font-size-14 font-weight-bold">
														<div class="border border-2px px-3 py-1">SURAT JALAN</div>
													</div>
												</div>
											</v-col>
										</div>
									</div>
									<v-row v-if="detailInvoice">
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Nomor</div>
													<div>Tanggal</div>
													<div>MC ID</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div>: {{ detailSDO.sdo_code }}</div>
													<div>: {{ detailSDO.sdo_status_on_delivery_datetime | tanggaljam }}</div>
													<div>: {{ detailSDO.customer_network_code }}</div>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="6" class="py-0">
											<v-row>
												<v-col cols="3" class="py-0 font-size-9">
													<div>Kepada</div>
													<div>Telepon</div>
													<div>Alamat</div>
												</v-col>
												<v-col cols="9" class="pl-0 py-0 font-size-9">
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSDO.customer_name }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ detailSDO.customer_mobilephone }}</div>
													</div>
													<div class="d-flex">
														<div>:</div>
														<div class="pl-1">{{ addresText }}</div>
													</div>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
									<div class="pt-3" v-if="detailProduct">
										<v-card outlined tile>
											<v-simple-table class="white-row">
												<template v-slot:default>
													<thead class="deep-purple lighten-5">
														<tr>
															<th class="text-left border-left" width="6%">No</th>
															<th class="text-left">Nama Produk</th>
															<th class="text-center">Qty</th>
															<th class="text-center border-right">Satuan</th>
														</tr>
													</thead>
													<tbody>
														<tr v-for="( product, index) in detailSDO.sdo_detail" :key="product.sdo_detail_id">
															<td class="text-left border-left">
																<div class="font-size-9">{{ index + 1 }}.</div>
															</td>
															<td class="text-left">
																<div class="font-size-9">{{ product.sdo_detail_product_name }}</div>
															</td>
															<td class="text-center">
																<div class="font-size-9">{{ product.sdo_detail_quantity_sent | toNumber }}</div>
															</td>
															<td class="text-center border-right">
																<div class="font-size-9">{{product.sdo_detail_product_unit}}</div>
															</td>
														</tr>
													</tbody>
												</template>
											</v-simple-table>
										</v-card>
									</div>
									<div class="mt-3" v-if="signature">
										<div class="d-flex justify-center">
											<v-col cols="5" class="px-0">
												<div class="text-center font-size-9">
													<div class="pb-5">Tanda Terima,</div>
													<div class="pt-5">({{ detailSDO.customer_name }})</div>
												</div>
											</v-col>
											<v-col cols="5" class="px-0">
												<div class="text-center font-size-9">
													<div class="pb-5">Hormat Kami,</div>
													<div class="pt-5">(PT. MILAGROS INDONESIA MEGAH)</div>
												</div>
											</v-col>
										</div>
									</div>
									<div v-if="note">
										<div class="pt-3 font-size-9 font-italic">Catatan : Bukti pengiriman ini harap disimpan***</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'
// import printJS from 'print-js'
import $ from 'jquery'

export default {
	data () {
		return {
			header: true,
			detailInvoice: true,
			detailProduct: true,
			signature: true,
			note : true,
			headersProduct: [
			{ text: 'Nama Produk', value: 'po_detail_product_name', sortable: false },
			{ text: 'Jumlah Pesanan', value: 'po_detail_quantity_requested', align: 'center', sortable: false },
			{ text: 'Jumlah Diterima', value: 'po_detail_quantity_delivered', align: 'center', sortable: false },
			{ text: 'Jumlah Dikirim', value: 'po_detail_quantity_transport', align: 'center', sortable: false },
			],
		}
	},
	computed: {
		...mapState('sdo', ['detailSDO']),
		...mapState('common', ['letterHeader']),
		...mapState('auth', ['userData']),

		addresText() {
			var data = []
			if (this.detailSDO) {
				if (this.detailSDO.customer_address)
					data.push(this.detailSDO.customer_address)
				if (this.detailSDO.customer_subdistrict_name)
					data.push(this.detailSDO.customer_subdistrict_name)
				if (this.detailSDO.customer_city_name)
					data.push(this.detailSDO.customer_city_name)
				if (this.detailSDO.customer_province_name)
					data.push(this.detailSDO.customer_province_name)
			}
			return data.join(', ')
		},
		grandTotal(){
			let total = 0
			if (this.detailSDO.sdo_detail) {
				this.detailSDO.sdo_detail.forEach( (el) => {
					total += el.sdo_detail_product_price * el.sdo_detail_quantity_sent
				});
			}
			return total
		}
	},
	props: {
		dialog: Boolean
	},
	methods: {
		hideDialog() {
			this.$emit('hideDialog')
		},
		async printDiv(val) {
			var tempTitle = await document.title
			document.title = await val
			await $("#app").find(".v-main").css({ display: "none" });
			await window.print()
			await $("#app").find(".v-main").css({ display: "block" });
			setTimeout(() => { document.title = tempTitle }, 1000)
		},
	},
	watch: {
		dialog(val) {
			if (!val) {
				this.header = true
				this.detailInvoice = true
				this.detailProduct = true
				this.signature = true
				this.note  = true
			}
		}
	},
};
</script>